module.exports = __webpack_public_path__ + "static/media/ic_emptyBag.20a095bf.png";